import { useEffect } from 'react'
import keys from '@/config/keys'

function getDocumentHeight() {
	const root = document.getElementById('root')

	if (root) {
		return root.scrollHeight
	}

	const body = document.body
	const doc = document.documentElement
	const minHeight = 500

	return Math.max(
		body ? body.scrollHeight : 0,
		body ? body.offsetHeight : 0,
		doc ? doc.scrollHeight : 0,
		doc ? doc.offsetHeight : 0,
		minHeight,
	)
}

export function sendWidgetResizeMessage(height) {
	if (!window.parent) return
	window.parent.postMessage({ type: keys.ELD_WIDGET_MESSAGES.RESIZE, height: height }, '*')
}

export function createWidgetResizeMessenger() {
	let lastSentHeight = 0
	const appBaseView = document.getElementById(keys.BASE_VIEW_WRAPPER_ID)
	if (appBaseView) {
		appBaseView.style.height = 'unset!important'
		appBaseView.style.minHeight = 'unset!important'
	}

	function sendHeight() {
		const height = getDocumentHeight()

		if (height > 0 && Math.abs(height - lastSentHeight) > 2 && window.parent) {
			lastSentHeight = height

			if (window.requestAnimationFrame) {
				window.requestAnimationFrame(function () {
					sendWidgetResizeMessage(height)
				})
			} else {
				sendWidgetResizeMessage(height)
			}
		}
	}

	function start() {
		console.log('Starting widget resize messenger')
		sendHeight()

		if (typeof ResizeObserver !== 'undefined') {
			console.log('Using ResizeObserver for widget resize messenger')
			const observer = new ResizeObserver(function () {
				sendHeight()
			})

			const root = document.getElementById('root')

			if (root) {
				observer.observe(root)
			} else if (document.body) {
				observer.observe(document.body)
			}

			return {
				sendHeight: sendHeight,
				stop: function () {
					observer.disconnect()
				},
			}
		}

		window.addEventListener('load', sendHeight)
		window.addEventListener('resize', sendHeight)

		const intervalId = window.setInterval(sendHeight, 500)

		return {
			sendHeight: sendHeight,
			stop: function () {
				window.removeEventListener('load', sendHeight)
				window.removeEventListener('resize', sendHeight)
				window.clearInterval(intervalId)
			},
		}
	}

	return {
		sendHeight: sendHeight,
		start: start,
	}
}

export function sendWidgetReloadMessage() {
	console.log('Sending widget reload message to parent')
	if (!window.parent) return
	window.parent.postMessage({ type: keys.ELD_WIDGET_MESSAGES.RELOAD }, '*')
	console.log('Widget reload message sent')
}

function getWheelTargetElement(target) {
	if (!target) return null
	if (target.nodeType === Node.ELEMENT_NODE) return target
	return target.parentElement || null
}

function isScrollableY(element) {
	if (!element) return false

	const styles = window.getComputedStyle(element)
	const overflowY = styles.overflowY
	const canOverflow = overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay'

	return canOverflow && element.scrollHeight > element.clientHeight + 1
}

function canScrollY(element, deltaY) {
	if (!element || !deltaY) return false

	if (deltaY > 0) {
		return element.scrollTop + element.clientHeight < element.scrollHeight - 1
	}

	return element.scrollTop > 0
}

function getScrollableWheelContainer(target, deltaY) {
	let element = getWheelTargetElement(target)

	while (element && element !== document.body && element !== document.documentElement) {
		if (isScrollableY(element) && canScrollY(element, deltaY)) return element
		element = element.parentElement
	}

	return null
}

function isInsideAntdModal(target) {
	const element = getWheelTargetElement(target)
	return !!element?.closest?.('.ant-modal-wrap, .ant-modal')
}

export function useWidgetScrollListener(isWidgetMode = false) {
	useEffect(() => {
		if (!isWidgetMode || !window.parent) return

		function onWheel(e) {
			const isModalWheel = isInsideAntdModal(e.target)
			if (isModalWheel && getScrollableWheelContainer(e.target, e.deltaY)) return

			e.preventDefault()

			if (isModalWheel) return

			window.parent.postMessage({ type: keys.ELD_WIDGET_MESSAGES.WHEEL, deltaY: e.deltaY }, '*')
		}
		window.addEventListener('wheel', onWheel, { passive: false })
		return () => {
			window.removeEventListener('wheel', onWheel)
		}
	}, [isWidgetMode])
}
